import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import ModalPopup from 'components/organisms/modal';
import Button from 'components/atoms/button';
import { FormGroup, Label } from 'reactstrap';

const UpdatePatientCovidStatusModal = ({
  isOpen,
  toggle,
  patientGuid,
  patientCovidStatus,
  options,
  loading,
  submit,
}) => {
  const handleSubmit = async (values) => {
    const postData = {
      patientGuid,
      covidStatus: values.status,
    };
    await submit(postData);
  };

  return (
    <ModalPopup
      isOpen={isOpen}
      toggle={toggle}
      title="Update Patient Covid Status"
      className="popup covid-popup"
    >
      <Formik
        initialValues={{ status: patientCovidStatus }}
        onSubmit={handleSubmit}
      >
        {({ values: { status } }) => (
          <Form>
            <div className="covid-popup-content">
              <FormGroup tag="fieldset">
                {options.map((option) => (
                  <FormGroup check key={option.id}>
                    <Label check>
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="status"
                        value={option.id}
                      />
                      {option.label}
                    </Label>
                  </FormGroup>
                ))}
              </FormGroup>
            </div>
            <div className="text-center">
              <Button
                type="submit"
                text="Update"
                disabled={loading || status === patientCovidStatus}
              />
            </div>
          </Form>
        )}
      </Formik>
    </ModalPopup>
  );
};

UpdatePatientCovidStatusModal.defaultProps = {
  isOpen: false,
};

UpdatePatientCovidStatusModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  patientGuid: PropTypes.string.isRequired,
  patientCovidStatus: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  submit: PropTypes.func.isRequired,
};

export default UpdatePatientCovidStatusModal;
